/**
 * @generated SignedSource<<571addbf28c8de6d248a088862ee0274>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceSignalEditMainProducts_Signal$data = {
  readonly id: string;
  readonly linkedProducts: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"LinkedWorkspaceProductItem_WorkspaceProduct">;
  }>;
  readonly " $fragmentType": "WorkspaceSignalEditMainProducts_Signal";
};
export type WorkspaceSignalEditMainProducts_Signal$key = {
  readonly " $data"?: WorkspaceSignalEditMainProducts_Signal$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceSignalEditMainProducts_Signal">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspaceSignalEditMainProducts_Signal",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "WorkspaceProduct",
      "kind": "LinkedField",
      "name": "linkedProducts",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "LinkedWorkspaceProductItem_WorkspaceProduct"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SignalWorkspace",
  "abstractKey": null
};
})();

(node as any).hash = "4723c9a1e73040d01aae9cd29eaf460c";

export default node;
